<template>
  <div class="orderbillcount">
        <div class="search">
          <el-date-picker
              style="margin-right:1%"
              v-model="startTime"
              type="month"
              value-format="yyyy-MM"
              format="yyyy-MM"
              @change="datechange"
              placeholder="销售月份">
          </el-date-picker>
          <el-button  v-preventReClick type="primary" @click="search()">查询</el-button>
      </div>
      <div class="listbtn">
          <el-button  v-preventReClick type="success" icon="el-icon-upload" @click="exportExcel()">导出报表</el-button>
      </div>
      <div class="tablelist">
          <el-table
            :data="tableData"
            :header-cell-style="{'background-color': '#F6F6F6','font-weight':'600','color': '#333','height':'20px'}"
            style="width: 100%">
            <el-table-column
                prop="month"
                label="销售月份"
                width="80">
            </el-table-column>
            <el-table-column
                prop="shopName"
                label="4S店名称"
                width="130">
            </el-table-column>
            <el-table-column
                prop="districtName"
                width="100"
                label="区域">
            </el-table-column>
            <el-table-column
               width="100"
                prop="payType"
                label="结算方式">
                <template slot-scope="scope">
                    {{scope.row.payType == 1?'月结':scope.row.payType == 2?'预付款':scope.row.payType == 3?'扫码付款':''}}
                </template>
            </el-table-column>
            <el-table-column
               width="130"
                prop="saleNum"
                label="订单销售数量">
            </el-table-column>
            <el-table-column
               width="130"
                prop="saleMoney"
                label="订单销售金额">
            </el-table-column>
            <el-table-column
               width="130"
                prop="revokeNum"
                label="订单作废数量">
            </el-table-column>
            <el-table-column
               width="130"
                prop="refundMoney"
                label="订单退款金额">
            </el-table-column>
            <el-table-column
               width="130"
                prop="saleCheckNum"
                label="订单对账数量">
            </el-table-column>
            <el-table-column
               width="130"
                prop="checkMoney"
                label="订单对账金额">
            </el-table-column>
            <el-table-column
               width="140"
                label="操作">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="detail(scope.row)">明细</el-link>
                    <el-link :underline="false" @click="onload(scope.row)">下载明细</el-link>
                </template>
            </el-table-column>
          </el-table>
      </div>
  </div>
</template>

<script>
import {saleStatistics} from '../axios/api'
export default {
    data(){
        return{
            startTime:'',
            tableData:[],
            page:1,
            total:0,
            states:0
        }
    },
    created(){
        this.getdata()
        var myDate = new Date()
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth()+Number(1);
        var nextMonth = Number(tMonth)
           console.log(nextMonth)
           if(nextMonth < 10){
               nextMonth = '0' + nextMonth
        }
        this.startTime = tYear+'-'+nextMonth
    },
    methods:{
        detail(row){
            console.log(row)
            this.$router.push({
                name:'对账单统计明细',
                params:{
                    row:row
                }
            })
        },
        async getdata(){
            var myDate = new Date()
            var tYear = myDate.getFullYear();
            var tMonth = myDate.getMonth()+Number(1);
            var nextMonth = Number(tMonth)
            console.log(nextMonth)
            if(nextMonth < 10){
                nextMonth = '0' + nextMonth
            }
            console.log(myDate,tYear,tMonth)
            var {data:dt} = await saleStatistics({
                month:nextMonth,
                shopId:window.localStorage.getItem('shopId'),
                year:tYear
            })
            console.log(dt)
            if(dt.code == 200){
                this.tableData = dt.data.finalList
            }
        },
        datechange(value){
            console.log(value)
            this.startTime = value
        },
        async search(){
            var myDate = new Date()
            var tYear = myDate.getFullYear();
            // var tMonth = myDate.getMonth();
            console.log(this.startTime)
            let year
            if(this.startTime){
                year = this.startTime.split('-')
            }
            console.log(year)
            var {data:dt} = await saleStatistics({
                 year:this.startTime?year[0]:tYear,
                 month:this.startTime?year[1]:'',
                 shopId:window.localStorage.getItem('shopId')
            })
            console.log(dt)
            if(dt.code == 200){
                this.tableData = dt.data.finalList
            }
        },
        exportExcel() {
            var myDate = new Date()
            var tYear = myDate.getFullYear();
            var tMonth = myDate.getMonth();
            window.location.href = `http://1.95.5.134:8088/carMessage/export/exportSaleStatistics1?billType=${1}&month=${this.startTime?this.startTime:tYear+'-'+ Number(tMonth+1)}&shopId=${window.localStorage.getItem('shopId')}`
        },
        onload(row){
            console.log(row)
            var myDate = new Date()
            var tYear = myDate.getFullYear();
            var tMonth = myDate.getMonth();
            window.location.href = `http://1.95.5.134:8088/carMessage/export/saleBillDetailStatistics?billType=${1}&saleMonth=${this.startTime?this.startTime:tYear+'-'+ Number(tMonth+1)}&shopId=${row.shopId}&payType=${row.payType}`
        }
    }
}

</script>
<style lang="less">
.orderbillcount{
    background: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .tablelist{
        margin-top: 15px;
        .el-link.el-link--default {
            color: #409eff;
            margin-right: 12px;
        }
    }
    .el-radio{
        margin-right: 10px!important;
    }
}
</style>